<template>
    <div class="botaoScrollTop" @click="ScrollTopoApp">
        <div class="setaBotaoSrollTop">&#10094;</div>
        <!--<div class="textoBotaoScrollTop"></div>-->
    </div>
</template>

<script>
let btn;

import VueScrollTo from 'vue-scrollto'

export default {
    name: 'BotaoScroll',
    components: { VueScrollTo },
    methods: {
        ScrollTopoApp() {
            this.$scrollTo('.header' , 1000);
        },
        MonitoraScroll() {
            if (window.scrollY > 600) {
                btn[0].style.display = "block";
            } else {
                btn[0].style.display = "none";
            }
        },
        montedBotao() {
            btn = document.getElementsByClassName("botaoScrollTop");
            btn[0].style.display = "none";
        }
    },
    created () {
        window.addEventListener('scroll', this.MonitoraScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.MonitoraScroll);
    },
    mounted() {
        this.montedBotao();
    }
}
</script>

<style>
.botaoScrollTop {
    background-image: linear-gradient(#2e2d2c, #999);
    /*background-image: linear-gradient(#008fac, #eee);*/
    /*background: #2e2d2c;*/
    border-radius: 50%;
    width: 40px;
    height: 40px;
    color:#eee;
    opacity: 0.6;
}
.botaoScrollTop:hover {
    cursor: pointer;
    box-shadow: 2px 2px 2px #2e2d2c;
    opacity: 1;
}
.setaBotaoSrollTop {
    position: relative;
    font-size: 2em;
    font-weight: bold;
    /*top:13%;*/
    top: 15%;
    left: 0px;
    transform: rotate(90deg);
    text-shadow: 2px 2px 2px #2e2d2c;
}
/*.textoBotaoScrollTop {
    position: relative;
    font-size: 0.8em;
    font-family: 'Play';
    font-weight: bold;
    top:-48%;
    left: 25%;
    text-shadow: 2px 2px 2px #2e2d2c;
}*/
</style>